export function comparePersonalScoresCB(personalScoreA, personalScoreB) {
  var result = 0;
  if (personalScoreA.point > personalScoreB.point) {
    result = -1;
  } else {
    result = 1;
  }
  return result;
}

export function sortPersonalScores(personalScores) {
  const clone = [...personalScores];
  return clone.sort(comparePersonalScoresCB);
}

export function kelvinToCelsius(kelvin) {
  var celsius = kelvin - 273.15;
  return celsius.toFixed(2);
}

export function calculateGravity(massRelativeToJp, radiusRelativeToJp) {
  // Universal gravitational constant (in appropriate units)
  const G = 6.6743e-11;

  // Convert mass and radius to absolute values
  var planetMass = calculateMass(massRelativeToJp);
  var planetRadius = calculateRadius(radiusRelativeToJp) * 1000;

  // Calculate the acceleration due to gravity
  var gravity = (G * planetMass) / (planetRadius * planetRadius);

  return gravity.toFixed(2);
}

export function calculateMassFormatted(M) {
  const Jupiter = 1.898e27;
  const massKg = M * Jupiter;
  const [coeff, exp] = massKg.toString().split("e");
  return (
    <>
      {parseFloat(coeff).toFixed(2)} · (10 <sup>{parseFloat(exp)}</sup>)
    </>
  );
}

export function calculateMass(M) {
  const Jupiter = 1.898e27;
  const massKg = M * Jupiter;
  return massKg;
}

export function calculateRadius(R) {
  const Jupiter = 69911;
  const radiusKm = R * Jupiter;
  return radiusKm;
}

export function ScoreAlgorithm(guessValue, actualValue) {
  // Logarithmic scoring
  // Base score of 5000 points
  const baseScore = 5000;

  if (guessValue === actualValue) return baseScore;

  // Score reduction factor
  // The score reduces logarithmically as the Value ratio increases
  // Adjust the multiplier to control the rate of decrease
  let score = 0;
  if (actualValue > guessValue)
    score = baseScore * Math.log2(guessValue / actualValue + 1);
  else score = baseScore * Math.log2(actualValue / guessValue + 1);

  // Calculate final score
  // Ensure the score is at least 0
  score = Math.max(score, 0);

  return Math.round(score);
}
